export const cognitoConfig = {
  region: window._env_.COGNITO_REGION || "us-east-2",
  userPoolId: window._env_.COGNITO_USER_POOL_ID || "",
  clientId: window._env_.COGNITO_CLIENT_ID || "",
  domain: window._env_.COGNITO_DOMAIN || "",
  // OAuth configuration
  redirectSignIn: `${window.location.origin}/login/callback`,
  redirectSignOut: `${window.location.origin}/login`,
  responseType: "code",
  scopes: ["openid", "email", "profile"],
};

export const getCognitoLoginUrl = () => {
  const { domain, clientId, redirectSignIn, responseType, scopes } =
    cognitoConfig;
  const params = new URLSearchParams({
    client_id: clientId,
    response_type: responseType,
    scope: scopes.join(" "),
    redirect_uri: redirectSignIn,
  });
  return `https://${domain}/oauth2/authorize?${params.toString()}&identity_provider=Google`;
};

export const getCognitoLogoutUrl = () => {
  const { domain, clientId, redirectSignOut } = cognitoConfig;
  // Cognito logout requires both client_id and logout_uri
  // logout_uri must be registered in the Cognito app client's allowed sign-out URLs
  const params = new URLSearchParams({
    client_id: clientId,
    logout_uri: redirectSignOut,
    redirect_uri: redirectSignOut,
  });
  return `https://${domain}/logout?${params.toString()}`;
};
